import { Modal, Button } from 'react-bootstrap';
import { useErrorModalStore } from '@infrastructure/api/store/errorModalStore';

export default function ValidationErrorModal() {
  const { validationErrors, dismiss } = useErrorModalStore();

  return (
    <Modal show={validationErrors !== null} onHide={dismiss} centered>
      <Modal.Header
        closeButton
        className="alert-warning border-warning mb-0"
      >
        <Modal.Title className="text-dark">Attention Required</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Please fix the following before continuing:</p>
        <ul className="mb-0">
          {validationErrors?.map((msg, i) => (
            <li key={i}>{msg}</li>
          ))}
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={dismiss}>
          Got it
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
